import Quill from 'quill';

export interface GridConfig {
  insertButtonSelector?: string; // not required for now
}

export default class GridModule {
  quill: Quill;
  options: GridConfig;

  static Quill: any;

  constructor(quill: Quill, options: GridConfig) {
    this.quill = quill;
    this.options = options;

    const toolbar = quill.getModule('toolbar') as any;
    if (toolbar && typeof toolbar.addHandler === 'function') {
      toolbar.addHandler('grid', this.insertGrid.bind(this));
    }
  }

  insertGrid() {
    const rows = parseInt(prompt('Enter number of rows', '2') || '2', 10);
    const cols = parseInt(prompt('Enter number of columns', '2') || '2', 10);

    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';

    for (let r = 0; r < rows; r++) {
      const tr = document.createElement('tr');
      for (let c = 0; c < cols; c++) {
        const td = document.createElement('td');
        td.style.border = '1px solid #ccc';
        td.style.padding = '8px';
        td.innerText = `R${r + 1}C${c + 1}`;
        tr.appendChild(td);
      }
      table.appendChild(tr);
    }

    const container = document.createElement('div');
    container.appendChild(table);

    const range = this.quill.getSelection(true);
    if (range) {
      this.quill.clipboard.dangerouslyPasteHTML(
        range.index,
        container.outerHTML
      );
      this.quill.setSelection(range.index + 1);
    }
  }
}

// quill-grid.module.ts
// export function quillGridModule(quill: any, options: any) {
//   const toolbar = quill.getModule('toolbar');

//   if (toolbar) {
//     toolbar.addHandler('grid', function () {
//       const rows = parseInt(prompt('Enter number of rows', '2') || '2', 10);
//       const cols = parseInt(prompt('Enter number of columns', '2') || '2', 10);

//       const table = document.createElement('table');
//       table.style.width = '100%';
//       table.style.borderCollapse = 'collapse';

//       for (let r = 0; r < rows; r++) {
//         const tr = document.createElement('tr');
//         for (let c = 0; c < cols; c++) {
//           const td = document.createElement('td');
//           td.style.border = '1px solid #ccc';
//           td.style.padding = '6px';
//           td.innerText = `R${r + 1}C${c + 1}`;
//           tr.appendChild(td);
//         }
//         table.appendChild(tr);
//       }

//       const container = document.createElement('div');
//       container.appendChild(table);

//       const range = quill.getSelection(true);
//       if (range) {
//         // use clipboard module to insert raw HTML
//         quill.clipboard.dangerouslyPasteHTML(range.index, container.outerHTML);
//         quill.setSelection(range.index + 1);
//       }
//     });
//   }
// }
